import {FlatButton} from 'material-ui';
import React from 'react';
import {withNamespaces} from 'react-i18next';
import styled from 'styled-components';
import config from '../../src/config';
import ActionButtonRow from '../components/ActionButtonRow';
import {ROLE_SUPER_ADMIN} from '../constants/userConstants';

export const Spacer = styled.div`
  height: 50px;
`;
export const SpacerSmall = styled.div`
  height: 25px;
`;

class OfferExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: '2023-04-01',
    };
  }

  _goBackToList = () => this.props.history.goBack();

  _renderButtons = () => {
    const {t} = this.props;
    return (
      <ActionButtonRow>
        <FlatButton
          onClick={this._goBackToList}
          label={t('collections.back')}
        />
      </ActionButtonRow>
    );
  };

  render() {
    const {t, user} = this.props;
    console.log(user);
    if (user.role !== ROLE_SUPER_ADMIN) {
      return null;
    }
    return (
      <div>
        <h1>{t('offerExport.headline')}</h1>
        <SpacerSmall />
        <div>
          <label>{t('offerExport.startDate')}</label>

          <input
            type='date'
            value={this.state.date}
            onChange={e => this.setState({date: e.target.value})}
            style={{marginLeft: '20px'}}
          />
        </div>
        <Spacer />
        <FlatButton
          target='_blank'
          href={`${
            config.exportUrl ? config.exportUrl : '/offer'
          }/api/export?startDate=${
            this.state.date
          }&token=${config.getAuthHeader()}`}
          label={t('offerExport.download')}
        />
      </div>
    );
  }
}

export default withNamespaces()(OfferExport);



// WEBPACK FOOTER //
// ./src/containers/OfferExport.js